import React from 'react';
import { CollapsablePanel } from './CollapsablePanel';
import { ApplicationMainOptions } from '../dialogs/ApplicationMainOptions';

import './ApplicationMainOptionsPanel.css';
import { useZoomStore } from '../../stores/ZoomStore';
import { RydUserSupportMainPanel } from './RydUserSupportMainPanel';
import { RydCollapsableCard } from '../widgets/RydCollapsableCard';

export function ApplicationMainOptionsPanel({
    isCollapsed,
    toggleCollapsed,
    setProject,
}: {
    isCollapsed: boolean,
    toggleCollapsed: () => void,
    setProject: (project: any) => void,
}) {

    return (
        <CollapsablePanel
            isCollapsed={isCollapsed}
            toggleCollapse={toggleCollapsed}
            extraClasses={['ryd-app-menu']}
            hideToggelWhenCollapsed={true}
        >
            <ApplicationMainOptions setProject={(p) => {
                toggleCollapsed();
                setProject(p);
            }} />

            <RydCollapsableCard title={"User support"} collapsed={true}>
                <RydUserSupportMainPanel />
            </RydCollapsableCard>
        </CollapsablePanel>

    );
}